import { ChevronDown } from "lucide-react";

/**
 * Accordion FAQ item — usato dalle landing page.
 * Props:
 *  - question: string
 *  - answer: string
 *  - isOpen: bool
 *  - onClick: () => void
 *  - testIdPrefix: string (es. "faq-item" o "haccp-faq-item")
 *  - index: number
 */
export const FaqItem = ({ question, answer, isOpen, onClick, testIdPrefix = "faq-item", index = 0 }) => (
  <div className="border-b border-gray-100 last:border-b-0">
    <button
      onClick={onClick}
      className="w-full flex items-center justify-between py-5 px-1 text-left group"
      data-testid={`${testIdPrefix}-${index}`}
    >
      <span className={`text-base font-semibold transition-colors ${isOpen ? "text-gray-900" : "text-gray-700 group-hover:text-gray-900"}`}>
        {question}
      </span>
      <ChevronDown
        className={`h-5 w-5 flex-shrink-0 ml-4 transition-transform duration-300 ${isOpen ? "rotate-180 text-indigo-500" : "text-gray-400"}`}
      />
    </button>
    <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-96 pb-5" : "max-h-0"}`}>
      <p className="text-sm text-black leading-relaxed px-1">{answer}</p>
    </div>
  </div>
);
